module.exports = __webpack_public_path__ + "static/media/logo.d4384bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 127
// module chunks = 0